/** The `accept` value for a PDF-only dropzone or file input. */
export const PDF_ACCEPT = "application/pdf,.pdf";

/** True for a PDF, by type or (when the browser gives no type) by name, in any letter case. */
export function isPdfFile(file: File): boolean {
  return file.type === "application/pdf" || /\.pdf$/i.test(file.name);
}
